<template>
  <div class="page" @touchmove.prevent>
    <div class="bg-window"></div>
    <div class="main">
      <!-- <div class="about-me">关于我</div>
      <div class="hint">你的身份？</div> -->
      <img class="pic-about-me" src="https://static.huiyiji520.com/cppic-1661154078.png">
      <img class="pic-hint" src="https://static.huiyiji520.com/cppic-1661167844.png">

      <div class="btn male" @click="chooseJob('student')" :style="{color: getBtnColor('student'), backgroundColor: getBtnBackground('student')}">学生</div>
      <div class="btn female" @click="chooseJob('worker')" :style="{color: getBtnColor('worker'), backgroundColor: getBtnBackground('worker')}">上班族</div>

      <div class="arrows">
        <div class="signs flex-box">
          <!-- <div class="prev" @click="goBack()"><van-icon name="arrow-left" color="#eb8e80" />上一步</div>
          <div class="next" @click="goNext()">下一步<van-icon name="arrow" color="#eb8e80" /></div> -->
          <img class="pic-prev" @click="goBack()" src="https://static.huiyiji520.com/cppic-1661159773.png">
          <img class="pic-next" @click="goNext()" src="https://static.huiyiji520.com/cppic-1661157292.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Icon } from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Icon.name]: Icon
  },
  data(){
    return {
      job: ''
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goBack(){
      this.$router.back()
    },
    goNext(){
      if(!this.job){
        Toast('请选择你的身份')
      }else{
        let cpchoose = this.$store.state.cpchoose
        cpchoose.myJob = this.job
        this.$store.commit('updateCpChoose', cpchoose)
        this.handleRouter('/choose_me_intro')
        // this.handleRouter('/choose_me_education')
      }
    },
    chooseJob(job){
      this.job = job
    },
    getBtnColor(job){
      return this.job == job ? '#fff' : '#f1b8af'
    },
    getBtnBackground(job){
      return this.job == job ? '#f1b8af' : '#fff'
    },
    recoverJobs(){
      this.job = this.$store.state.cpchoose.myJob ? this.$store.state.cpchoose.myJob : this.job
    }
  },
  mounted(){
    this.recoverJobs()
    this.$report.submit('/choose_me_jobs', this.$store.state.issue, this.$store.state.userinfo.openid)
  }
}
</script>

<style scoped>
.page{min-height:100vh;}
.bg-window{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-image: url("https://static.huiyiji520.com/cppic-1661155471.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  /* opacity:0.1; */
  z-index:-1;
}
.main{text-align:center;}
.main .about-me{margin-top:200px;margin-bottom:134px;font-size:70px;color:#eb8e80;}
.main .hint{font-size:40px;line-height:40px;color:#eb8e80;margin-bottom:160px;}
.main .pic-about-me{width:206px;height:68px;margin:0 auto;margin-top:208px;margin-bottom:146px;}
.main .pic-hint{width:186px;height:40px;margin:0 auto;margin-bottom:160px;}
.main .btn{
  width:342px;height:110px;line-height:110px;font-size:40px;border:5px solid #f1b8af;border-radius:30px;
  margin:0px auto;color:#f1b8af;background:#fff;
}
.main .btn.female{margin-top:80px;}
.main .arrows{position: fixed;bottom:120px;width:100%;}
.main .arrows .signs{
  justify-content:space-between;padding:0px 194px;
  font-size:32px;color:#eb8e80;
}
.main .pic-prev{width:120px;height:32px;}
.main .pic-next{width:120px;height:32px;}
</style>
